import { render, staticRenderFns } from "./CustomerDB.vue?vue&type=template&id=00eac6fa&"
import script from "./CustomerDB.vue?vue&type=script&lang=js&"
export * from "./CustomerDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports